module.exports = __webpack_public_path__ + "media/images/locations-bg-cdb69b8cdc1b50d938243bf90a367e06.jpg";